import {stripHtml} from './GeneralUtils';

/**
 * Format money using Javascripts Intl NumberFormatter
 * @param {float} amount            - Use standard currency increment. eg. "dollars" 10.00
 * @param {string} currency         - 3 letter ISO code
 * @param {string} locale           - 2 letter or 4 letter ISO code.
 * @param {string} currencyDisplay  - Level of formatting.
 */
export const formatIntlMoney = (
  amount: any,
  currency: string,
  locale = 'en',
  fallbackFormat: string|undefined|null = null,
  currencyDisplay = 'narrowSymbol'
) => {

  let formattedAmount = amount;

  try {

    const formatter = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      currencyDisplay: currencyDisplay
    });

    formattedAmount = formatter.format(amount);

  } catch (e) {

    console.warn("An error occurred formatting money - using fallback formatter", e, amount, currency, locale);

    if (fallbackFormat !== null) {
      formattedAmount = formatMoney(amount * 100, fallbackFormat);
    } else {
      formattedAmount = amount.toFixed(2);
    }

  }

  return formattedAmount;


}

/**
 * Used to format money with the Shopify currency format
 * @param {integer} cents
 * @param {string} format eg. ${{amount}}
 */
export const formatMoney = function (cents: string|number, format: string) {
  if (typeof cents == 'string') { cents = cents.replace('.', ''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format;

  function defaultOption(opt: any, def: any) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number: any, precision: number, thousands?: string, decimal?: string) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    number = number * 1;
    
    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  const formatStringMatch = formatString?.match(placeholderRegex);
  const testCase = formatStringMatch && typeof(formatStringMatch[1]) === 'string' ? formatStringMatch[1] : '';

  switch (testCase) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_comma_separator':
      value = formatWithDelimiters(cents, 2, '');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return stripHtml(formatString.replace(placeholderRegex, value));
};

/**
 * Used for the Shopify money formatter above.
 */
export const moneyWithCurrency = (cents: any, format: any, currency: any) => {
  const formatted_money = formatMoney(cents, format);
  return `${formatted_money} ${currency}`
}

/**
 * Used for the Shopify money formatter above.
 */
export const formattedMoney = (cents: any, format: any) => {
  const formatted_money = formatMoney(cents, format);
  return formatted_money;
}
